import React from "react";

export const LocationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 2a5.5 5.5 0 0 0-5.5 5.5c0 2.9 3.07 6.74 4.87 8.8a.82.82 0 0 0 1.26 0c1.8-2.06 4.87-5.9 4.87-8.8A5.5 5.5 0 0 0 10 2Zm0 7.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </svg>
);
